export class Config {
  isFun: boolean;
  wordApiKey: string;
  flickrApiKey: string;
  flickrSecret: string;
  flickrGalleryId: string;
  flowerShow: FlowerShow;
}

export class FlowerShow {
  link: string;
  date: string;
}
